import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Dialog } from "@/components/ui/Dialog";
import { useShortcuts } from "@/lib/keyboard";

/** Event the user menu sends to open this help without owning its state. */
export const SHORTCUTS_EVENT = "tv:shortcuts";

const KEYS: [string[], string][] = [
  [["/"], "search"],
  [["j", "k"], "move"],
  [["Invio"], "open"],
  [["u"], "back"],
  [["s"], "favorite"],
  [["?"], "help"],
  [["Esc"], "close"],
];

export function ShortcutsDialog() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  useShortcuts({ "?": () => setOpen(true) });
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(SHORTCUTS_EVENT, show);
    return () => window.removeEventListener(SHORTCUTS_EVENT, show);
  }, []);
  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
      title={t("shortcuts.title")}
      description={t("shortcuts.intro")}
    >
      <dl className="grid grid-cols-[auto_1fr] items-baseline gap-x-5 gap-y-3 text-sm">
        {KEYS.map(([keys, action]) => (
          <div key={action} className="contents">
            <dt className="flex gap-1">
              {keys.map((key) => (
                <kbd
                  key={key}
                  className="rounded border border-line-strong bg-surface-2 px-1.5 text-xs leading-5 font-medium"
                >
                  {key === "Invio" ? t("shortcuts.enter") : key}
                </kbd>
              ))}
            </dt>
            <dd className="text-ink-muted">{t(`shortcuts.${action}`)}</dd>
          </div>
        ))}
      </dl>
    </Dialog>
  );
}
